import React, { Component } from "react";
import styled from "styled-components";

import { Switch } from "@material-ui/core";

import { Icon } from "./Icon";
import { themeColors } from "js/react/sharedStyles";

const Mixed = styled.div`
    text-transform: uppercase;
    font-size: 11px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border: solid 1px #ccc;
    padding: 6px 10px;
    background: #ddd;
`;

const StyledSwitch = styled(Switch)`
    &&& {
        height: 31px;
        padding: 9px 12px;

        .MuiSwitch-switchBase {
            padding: 5px;
            &.Mui-checked {
                transform: translateX(22px);
            }
        }

        .MuiSwitch-colorPrimary.Mui-checked {
            color: #11a9e2;
        }

        .MuiSwitch-colorPrimary.Mui-disabled {
            color: #ccc;
        }

        .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
            background-color: #11a9e2;
        }

        .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track {
            background-color: #555;
        }

        /* MUI's switch is built for a light page: the off-state track is black at 38% opacity, which
           on a dark surface is simply not there, and both thumbs are tinted rather than white, so
           what is left is a pale dot on nothing.

           Rebuilt here as a solid switch — an opaque track in both states with a white thumb riding
           it — because the thing that makes a switch readable at a glance is the contrast between
           thumb and track, and a translucent track on a dark ground has none to offer. Solid blue
           also makes "on" legible without having to work out which end the thumb is at. */
        ${({ $onDark }) => $onDark && `
            .MuiSwitch-switchBase {
                color: #fff;
            }

            .MuiSwitch-switchBase + .MuiSwitch-track {
                background-color: rgba(255, 255, 255, 0.28);
                opacity: 1;
            }

            .MuiSwitch-colorPrimary.Mui-checked {
                color: #fff;
            }

            .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
                background-color: ${themeColors.ui_blue};
                opacity: 1;
            }

            .MuiSwitch-colorPrimary.Mui-disabled {
                color: #999;
            }

            .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track {
                background-color: rgba(255, 255, 255, 0.12);
                opacity: 1;
            }
        `}
    }
`;

export class ToggleSwitch extends Component {
    triggerAction = () => {
        this.props.onChange(!this.props.value);
    }

    render() {
        const { id, value = false, onChange, disabled, onDark = false, ["data-test-id"]: dataTestId } = this.props;

        if (value == "mixed") {
            return <Mixed onClick={() => onChange(true)}>MIXED</Mixed>;
        } else {
            return (
                <StyledSwitch
                    id={id}
                    checked={value}
                    color="primary"
                    edge="end"
                    disabled={disabled}
                    $onDark={onDark}
                    onChange={event => onChange(event.target.checked)}
                    data-test-id={dataTestId}
                />
            );
        }
    }
}

const ToggleIconContainer = styled.div`
    position: relative;
    width: 32px;
    height: 32px;
    border-radius: ${props => props.round ? "50%" : "2px"};
    background: ${props => props.value ? themeColors.ui_blue50percent : "#ccc"};
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${props => props.disabled ? 0.5 : 1};
`;

export class ToggleIcon extends Component {
    render() {
        const { icon, iconOff, value = false, onChange, round, disabled } = this.props;

        if (value == "mixed") {
            return <Mixed onClick={() => onChange(true)}>MIXED</Mixed>;
        } else {
            return (
                <ToggleIconContainer value={value} onClick={() => onChange(!value)} round={round} disabled={disabled}>
                    <Icon color="rgba(0,0,0,.4)">{value ? icon : (iconOff ? iconOff : icon)}</Icon>
                </ToggleIconContainer>
            );
        }
    }
}

